export const widgetConfig = {
    hotelId: 'alecad',
    ticker: '',
    engine: 'witbooking',
    showPrice: false,
    defaultAdults: 2,
    defaultChildren: 0,
    currency: 'EUR',
    baseUrl: 'https://engine.prod.witbooking.com/',
    urlChain: 'chain/alegria_agr',
    urlHotel: 'hotel',
    showChildAges: true,
    noOnDesktop: false,
    type: 'chain',
    maxRooms: '5',
    showAllHotelsOption: 'true',
    targetBlank: true,
    maxDate: '2028-01-07',
};
